export default {
    taxes: ( state ) => {
        return state.taxes;
    }
}